var map = {
	"./template.bet575": 2034,
	"./template.bet575.tsx": 2034,
	"./template.bet777": 2035,
	"./template.bet777.tsx": 2035,
	"./template.betbetbet": 2000,
	"./template.betbetbet.tsx": 2000,
	"./template.betgalaxy": 1159,
	"./template.betgalaxy.tsx": 1159,
	"./template.betprofessor": 2036,
	"./template.betprofessor.tsx": 2036,
	"./template.betroyale": 2037,
	"./template.betroyale.tsx": 2037,
	"./template.betstride": 2038,
	"./template.betstride.tsx": 2038,
	"./template.buffalobet": 2039,
	"./template.buffalobet.tsx": 2039,
	"./template.chromabet": 2040,
	"./template.chromabet.tsx": 2040,
	"./template.default": 664,
	"./template.default.tsx": 664,
	"./template.epicodds": 2041,
	"./template.epicodds.tsx": 2041,
	"./template.fiestabet": 2001,
	"./template.fiestabet.tsx": 2001,
	"./template.forsport": 1160,
	"./template.forsport.tsx": 1160,
	"./template.gigabet": 2042,
	"./template.gigabet.tsx": 2042,
	"./template.goldenbet888": 1988,
	"./template.goldenbet888.tsx": 1988,
	"./template.goldenrush": 2043,
	"./template.goldenrush.tsx": 2043,
	"./template.hyperbet": 2044,
	"./template.hyperbet.tsx": 2044,
	"./template.juicybet": 2045,
	"./template.juicybet.tsx": 2045,
	"./template.junglebet": 2046,
	"./template.junglebet.tsx": 2046,
	"./template.magnumbet": 2047,
	"./template.magnumbet.tsx": 2047,
	"./template.oldgill": 2002,
	"./template.oldgill.tsx": 2002,
	"./template.puntcity": 2003,
	"./template.puntcity.tsx": 2003,
	"./template.puntgenie": 2048,
	"./template.puntgenie.tsx": 2048,
	"./template.pyramidbet": 1989,
	"./template.pyramidbet.tsx": 1989,
	"./template.questbet": 2004,
	"./template.questbet.tsx": 2004,
	"./template.slambet": 2005,
	"./template.slambet.tsx": 2005,
	"./template.sterlingparker": 1161,
	"./template.sterlingparker.tsx": 1161,
	"./template.sugarcastle": 2049,
	"./template.sugarcastle.tsx": 2049,
	"./template.templebet": 2050,
	"./template.templebet.tsx": 2050,
	"./template.titanbet": 2051,
	"./template.titanbet.tsx": 2051,
	"./template.ts": 383,
	"./template.vikingbet": 2006,
	"./template.vikingbet.tsx": 2006,
	"./template.volcanobet": 1986,
	"./template.volcanobet.tsx": 1986,
	"./template.wellbet": 2052,
	"./template.wellbet.tsx": 2052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2438;